import React, { useState, useEffect, useRef } from "react";
import { IoMdAdd } from "react-icons/io";
import { FaMinus } from "react-icons/fa6";
import { faqs } from "../../data/text";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const faqRefs = useRef([]);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    // Animate FAQ items on scroll
    if (faqRefs.current.length > 0) {
      faqRefs.current.forEach((el, i) => {
        gsap.from(el, {
          y: 50,
          opacity: 0,
          duration: 0.8,
          delay: i * 0.1, // stagger effect
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 90%",
            toggleActions: "play none none none",
          },
        });
      });
    }
  }, []);

  return (
    <div className="text-black flex justify-center">
      <div className="w-full max-w-7xl px-4 pt-20 pb-16 flex flex-col gap-6 items-center">
        {faqs.map((faq, index) => (
          <div
            key={index}
            ref={(el) => (faqRefs.current[index] = el)}
            className="w-full sm:w-[90%] md:w-[700px] px-4 py-4 gradient-background rounded-xl"
          >
            {/* Question Button */}
            <button
              onClick={() => toggleFAQ(index)}
              className="flex items-center justify-between w-full text-left"
            >
              <p className="text-[16px] sm:text-[18px] md:text-[20px] font-Outfit">
                {faq.question}
              </p>
              {activeIndex === index ? (
                <FaMinus className="text-[#000] text-lg sm:text-xl" />
              ) : (
                <IoMdAdd className="text-[#000] text-lg sm:text-xl" />
              )}
            </button>

            {/* Answer Content */}
            <div
              className={`transition-all duration-300 ease-in-out overflow-hidden ${
                activeIndex === index
                  ? "max-h-60 py-4 opacity-100"
                  : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-black text-[14px] sm:text-[16px] md:text-[18px] font-Outfit">
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;
